<!-- TEMPLATE CONTRACT: Ui Pipeline Strip Component owns the visible Angular template structure for src/app/shared/ui/ui-pipeline-strip/ui-pipeline-strip.component.html. -->
<ol class="ui-pipeline-strip">
  <!-- Repeated block documents how collection data renders in the UI. -->
  @for (stage of stages(); track stage.id; let last = $last; let first = $first) {
    <li class="ui-pipeline-strip__stage">
      <span class="ui-pipeline-strip__badge">{{ first ? '01' : stage.id }}</span>
      <span class="ui-pipeline-strip__label">{{ stage.label }}</span>
    </li>

    <!-- Conditional branch documents the visible UI state for this condition. -->
    @if (!last) {
      <li class="ui-pipeline-strip__connector" aria-hidden="true"></li>
    }
  }
</ol>
